import { defineComponent as i, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as f } from "../hooks/useScalarIcon.js";
const k = { key: 0 }, M = { key: 1 }, Z = { key: 2 }, h = { key: 3 }, w = { key: 4 }, y = { key: 5 }, A = {
  name: "ScalarIconControl"
}, L = /* @__PURE__ */ i({
  ...A,
  props: {
    label: {},
    weight: {}
  },
  setup(a) {
    const s = a, { bind: d, weight: r } = f(s);
    return (p, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(r) === "bold" ? (l(), o("g", k, t[0] || (t[0] = [
        n("path", { d: "M208.49,128.49a12,12,0,0,1-17,0L128,65,64.49,128.49a12,12,0,0,1-17-17l72-72a12,12,0,0,1,17,0l72,72A12,12,0,0,1,208.49,128.49Z" }, null, -1)
      ]))) : e(r) === "duotone" ? (l(), o("g", M, t[1] || (t[1] = [
        n("path", {
          d: "M200,120H56l72-72Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M205.66,114.34l-72-72a8,8,0,0,0-11.32,0l-72,72A8,8,0,0,0,56,128H200a8,8,0,0,0,5.66-13.66ZM75.31,112,128,59.31,180.69,112Z" }, null, -1)
      ]))) : e(r) === "fill" ? (l(), o("g", Z, t[2] || (t[2] = [
        n("path", { d: "M207.39,123.06A8,8,0,0,1,200,128H56a8,8,0,0,1-5.66-13.66l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,207.39,123.06Z" }, null, -1)
      ]))) : e(r) === "light" ? (l(), o("g", h, t[3] || (t[3] = [
        n("path", { d: "M204.24,124.24a6,6,0,0,1-8.48,0L128,56.49,60.24,124.24a6,6,0,0,1-8.48-8.48l72-72a6,6,0,0,1,8.48,0l72,72A6,6,0,0,1,204.24,124.24Z" }, null, -1)
      ]))) : e(r) === "regular" ? (l(), o("g", w, t[4] || (t[4] = [
        n("path", { d: "M205.66,125.66a8,8,0,0,1-11.32,0L128,59.31,61.66,125.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,205.66,125.66Z" }, null, -1)
      ]))) : e(r) === "thin" ? (l(), o("g", y, t[5] || (t[5] = [
        n("path", { d: "M202.83,122.83a4,4,0,0,1-5.66,0L128,53.66,58.83,122.83a4,4,0,0,1-5.66-5.66l72-72a4,4,0,0,1,5.66,0l72,72A4,4,0,0,1,202.83,122.83Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  L as default
};
